import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-access-denied',
  templateUrl: './admin-access-denied.component.html',
  styleUrls: ['./admin-access-denied.component.scss']
})
export class AdminAccessDeniedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
